export enum Bank {
    Swedbank = 'swedbank',
    Seb = 'seb',
    Luminor = 'luminor',
    Lhv = 'lhv',
    CoopPank = 'coopPank',
    NoEInvoice = 'noEInvoice',
}
